/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import privacyStyle from "@/src/components/Privacy/privacyStyle";
import { LAW_FIRM_ADDRESS, LAW_FIRM_ADDRESS_LOCALITY, LAW_FIRM_NAME, LAW_FIRM_POSTAL_CODE, SERVICE_EMAIL } from "@/src/services/globalVars";
import { Link } from "react-router";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const PrivacyLawFirm = () => {
  return (
    <Box sx={privacyStyle.privacyPage} id="datenschutz">
      <Typography variant={"h1"} sx={privacyStyle.headline}>
        Datenschutz
      </Typography>
      <Typography variant={"h2"} sx={privacyStyle.headline}>
        Datenschutzerklärung der Legalbird Rechtsanwälte Rechtsanwalts GmbH
      </Typography>
      <Typography variant={"h3"} sx={privacyStyle.headline}>
        Einleitung
      </Typography>
      <p>
        Für die Legalbird Rechtsanwälte Rechtsanwalts GmbH (<strong>"LBRA"</strong>) ist der Schutz und die Vertraulichkeit Ihrer Daten von besonderer
        Bedeutung. Die Erhebung und Verwendung Ihrer personenbezogenen Daten erfolgt ausschließlich im Rahmen der gesetzlichen Bestimmungen des geltenden
        Datenschutzrechts. Mit dieser Datenschutzerklärung informieren wir Sie darüber, welche personenbezogenen Daten LBRA erhebt und zu welchem Zweck die
        Daten verwendet werden und ggf. weitergegeben werden.
      </p>
      <p>
        Bitte lesen Sie diese Datenschutzerklärung sorgfältig durch, bevor Sie unsere Website (<strong>„Website“</strong>) nutzen. Die Nutzung unserer Website
        ist nur möglich, wenn Sie bestätigen, dass Sie diese Datenschutzerklärung zur Kenntnis genommen haben und der Verarbeitung Ihrer personenbezogenen Daten
        zustimmen, soweit dies für die Erbringung der juristischen Dienstleistungen (<strong>„Dienste“</strong>) erforderlich ist. Optionalen
        Datenverarbeitungen, etwa zu Marketingzwecken, können Sie gesondert zustimmen oder widersprechen. Falls Sie mit den zwingend notwendigen Verarbeitungen
        Ihrer personenbezogenen Daten nicht einverstanden sind, ist eine Nutzung der Website leider nicht möglich.
      </p>
      <br />
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Verantwortliche Stelle
      </Typography>
      Verantwortlicher im Sinne des Art. 4 Ziff. 7 DSGVO für die Verarbeitung personenbezogener Daten ist:
      <br />
      <br />
      {LAW_FIRM_NAME}
      <br />
      {LAW_FIRM_ADDRESS}
      <br />
      {LAW_FIRM_POSTAL_CODE} {LAW_FIRM_ADDRESS_LOCALITY}
      <br />
      Telefon: 0221 98651940
      <br />
      Email: <a href="mailto://service@legalbird.de">service@legalbird.de</a>
      <br />
      <br />
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Datenschutzbeauftragter
      </Typography>
      Bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten, sowie zu Ihren Rechten rund um den Datenschutz wenden Sie sich bitte an:
      <br />
      <br />
      E-Mail: <a href="mailto://datenschutz@legalbird-kanzlei.de">datenschutz@legalbird-kanzlei.de</a>
      <br />
      <br />
      <Typography variant={"h3"} sx={privacyStyle.headline}>
        I. Erhebung, Verarbeitung und Nutzung Ihrer Daten
      </Typography>
      <p>
        Zur Bereitstellung unserer Dienste ist die Erhebung, Verarbeitung und Nutzung von Daten und Informationen zu Ihrer Person (
        <strong>"personenbezogene Daten"</strong>) erforderlich. Wir verwenden Ihre personenbezogenen Daten gemäß Art. 6 Abs. 1 lit. b DSGVO ausschließlich zur
        Bereitstellung unserer Dienste für Sie bzw. aufgrund Ihrer Einwilligung gemäß Art. 9 Abs. 2 lit. a DSGVO.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Nutzungsdaten
      </Typography>
      <p>
        Zur Herstellung der Verbindung, Gewährleistung der Systemsicherheit und aus Gründen der technischen Administration, sowie um die Qualität und die
        Funktionsfähigkeit unserer Webseite zu verbessern und für den Fall einer Strafverfolgung sowie zu statistischen Zwecken erheben wir automatisch Daten
        über den einzelnen Zugriff auf unsere Seiten. Dieser Datensatz besteht unter anderem aus
      </p>
      <ul>
        <li>der Seite, von der aus die Plattform bzw. Webseite angefordert wurde,</li>
        <li>innerhalb der Webseite aufgerufenen Seiten,</li>
        <li>dem Datum und der Uhrzeit der Abfrage,</li>
        <li>der übertragenen Datenmenge,</li>
        <li>dem Zugriffsstatus (Datei übertragen, Datei nicht gefunden),</li>
        <li>Beschreibung des Typs des verwendeten Webbrowsers,</li>
        <li>der IP-Adresse des anfragenden Rechners</li>
        <li>dem verwendeten Betriebssystem</li>
      </ul>
      <p>Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des Verantwortlichen).</p>
      <p>Die o.g. Gründe stellen auch das berechtigte Interesse für die Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO dar.</p>
      <br />
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Cookies
      </Typography>
      <p>
        Zur besseren Benutzerführung setzen wir Cookies ein. Durch die Verwendung von Cookies wird die Nutzung von Webseiten für den Nutzer vereinfacht.
        Bestimmte Seiten sind ohne deren Einsatz nicht oder nicht fehlerfrei aufrufbar. Diese Gründe stellen auch das berechtigte Interesse für diese
        Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO dar (die Nutzung von Cookies zu Analysezwecken wird in einem anderen Punkt behandelt). Gängige Browser
        bieten die Einstellungsmöglichkeit, Cookies nicht zuzulassen. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert
        werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies ausschließen oder das automatische Löschen der Cookies beim Schließen des
        Browsers aktivieren. Es ist nicht gewährleistet, dass Sie auf alle Funktionen dieser Website ohne Einschränkungen zugreifen können, wenn Sie
        entsprechende Einstellungen vornehmen.
      </p>
      <p>
        Einen Überblick über die insgesamt auf Legalbird eingesetzten Technologien finden Sie in unserer <Link to={"/cookierichtlinie"}>Cookierichtlinie</Link>.
        Dort können Sie auch jederzeit Ihre Präferenzen hinsichtlich Ihrer Zustimmung ändern. Die jeweiligen Datenschutzerklärungen finden Sie bei den
        Betreibern der jeweiligen Services.
      </p>
      <br />
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Google Analytics
      </Typography>
      <p>
        LBRA benutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland („Google“). Google
        Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie
        ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA
        übertragen und dort gespeichert. Auf dieser Webseite wurde Google Analytics um den Code „gat._anonymizeIp();“ erweitert, um eine anonymisierte Erfassung
        von IP-Adressen (sog. IP-Masking) zu gewährleisten. Dadurch wird Ihre IP-Adresse vorab von Google innerhalb der EU-Mitgliedsstaaten oder weiteren
        Mitgliedsstaaten oder des Europäischen Wirtschaftsraums gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA
        übertragen und dort gekürzt. Im Auftrag von LBRA wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die
        Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber LBRA zu
        erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Sie
        können die Erfassung der durch den Google-Analytics-Cookie generierten Daten, die sich auf die Nutzung der Webseite beziehen (einschließlich der
        IP-Adresse), durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
        gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das
        Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google
        verhindern, indem sie das unter dem folgenden Link verfügbare
        <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Browser-Plugin{" "}
        </a>
        herunterladen und installieren.
      </p>
      <p>
        Sie können die Erfassung durch Google Analytics verhindern, indem Sie auf{" "}
        <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer nofollow">
          diesen Link
        </a>{" "}
        klicken. Es wird ein Opt-Out-Cookie gesetzt, das die zukünftige Erfassung Ihrer Daten beim Besuch dieser Plattform verhindert
      </p>
      <p>
        Weitere Informationen zur Verwendung Ihrer Daten durch google finden Sie
        <a href="https://www.google.com/analytics/terms/de.html" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          hier
        </a>{" "}
        und
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          hier
        </a>
        .
      </p>
      <p>
        Die Speicherung von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. LBRA hat ein berechtigtes Interesse an der Analyse
        des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren und dient damit auch der Finanzierung und kundenorientierten
        Nutzung, Anpassung und Aktualisierung der Webseite.
      </p>
      <br />
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Verwendung von Google Adwords Conversion-Tracking
      </Typography>
      <p>
        Wir verwenden auf unserer Website das Online-Werbeprogramm „Google AdWords“ und in diesem Rahmen Conversion-Tracking (Besuchsaktionsauswertung). Das
        Google Conversion Tracking ist ein Analysedienst von Google. Wenn Sie auf eine von Google geschaltete Anzeige klicken, wird ein Cookie für das
        Conversion-Tracking auf Ihrem Rechner abgelegt. Zu diesem Cookie werden in der Regel als Analyse-Werte die Unique Cookie-ID, Anzahl Ad Impressions pro
        Platzierung (Frequency), letzte Impression (relevant für Post-View-Conversions) sowie Opt-out-Informationen (Markierung, dass der Nutzer nicht mehr
        angesprochen werden möchte) gespeichert. Diese Cookies haben eine begrenzte Gültigkeit, enthalten keine personenbezogenen Daten und dienen somit nicht
        der persönlichen Identifizierung. Wenn Sie bestimmte Seiten unserer Website besuchen und das Cookie noch nicht abgelaufen ist, können Google und wir
        erkennen, dass Sie auf die Anzeige geklickt haben und zu dieser Seite weitergeleitet wurden. Jeder Google AdWords-Kunde erhält ein anderes Cookie. Somit
        besteht keine Möglichkeit, dass Cookies über die Websites von AdWords-Kunden nachverfolgt werden können.
      </p>
      <p>
        Die Informationen, die mit Hilfe des Conversion-Cookies eingeholt werden, dienen dem Zweck Conversion-Statistiken zu erstellen. Hierbei erfahren wir die
        Gesamtanzahl der Nutzer, die auf eine unserer Anzeigen geklickt haben und zu einer mit einem Conversion-Tracking-Tag versehenen Seite weitergeleitet
        wurden. Wir bekommen von Google lediglich statistische Auswertungen zur Verfügung gestellt. Anhand dieser Auswertungen können wir erkennen, welche der
        eingesetzten Werbemaßnahmen besonders effektiv sind. Weitergehende Daten aus dem Einsatz der Werbemittel erhalten wir nicht, insbesondere können wir die
        Nutzer nicht anhand dieser Informationen identifizieren. Die Verarbeitung erfolgt auf Grundlage des Art. 6 (1) lit. f DSGVO aus dem berechtigten
        Interesse an zielgerichteter Werbung und der Analyse der Wirkung und Effizienz dieser Werbung.
      </p>
      <p>
        Sie haben das Recht aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit dieser auf Art. 6 (1) f DSGVO beruhenden Verarbeitung Sie
        betreffender personenbezogener Daten zu widersprechen. Dazu können Sie die Speicherung der Cookies durch die Auswahl entsprechender technischer
        Einstellungen Ihrer Browser-Software verhindern.
      </p>
      <p>
        Des Weiteren können Sie in den Einstellungen für Werbung bei Google für Sie personalisierte Werbung deaktivieren. Hier finden Sie eine
        <a href="https://www.google.de/settings/ads" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Anleitung von Google{" "}
        </a>{" "}
        dazu. Darüber hinaus können Sie die Verwendung von Cookies durch Drittanbieter deaktivieren, indem sie die
        <a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Deaktivierungsseite der Netzwerkwerbeinitiative{" "}
        </a>
        (Network Advertising Initiative) aufrufen und die dort genannten weiterführenden Information zum Opt-Out umsetzen. Weiterführende Informationen sowie
        die Datenschutzerklärung von Google finden Sie{" "}
        <a href="https://www.google.de/policies/privacy/" target="_blank" rel="noopener noreferrer nofollow">
          hier
        </a>
        .
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Google Maps Autocomplete
      </Typography>
      <p>
        Zur komfortablen Eingabe von Adressdaten und zur Vermeidung von Übertragungsfehlern in der Antragsstrecke nutzen wir Google Maps Autocomplete (Google
        Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland). Sobald Sie eine Adresse eingeben, werden diese Daten und Ihre IP-Adresse an Google
        übertragen, um passende Vorschläge anzuzeigen. Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO, die Sie über
        unseren Cookie-Banner erteilt haben. Sie können diese Einwilligung jederzeit über die Cookie-Präferenzen widerrufen. Weitere Informationen finden Sie in
        der
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer nofollow">
          {" "}
          Datenschutzerklärung von Google
        </a>
        .
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Webfonts
      </Typography>
      <p>
        Auf dieser Webseite verwenden wir Web-Fonts (GoogleFonts, Adobe Typekit, Fonts.com o.ä.), also Schriften, die u.U. nicht auf Ihrem Endgerät vorhanden
        sind. Für diesen Dienst greifen wir auf eine Schrifttypenbibliothek zurück. Beim Aufruf unserer Webseite werden Web-Fonts von einem Server (Google,
        Adobe o.ä.) geladen. Dabei kann die IP-Adresse der aufrufenden Besucher an den Anbieter (z.B. Google, Adobe - Adobe Systems Inc., San Jose, Kalifornien,
        USA) übertragen werden. (GoogleFonts-Opt-out: https://adssettings.google.com)
      </p>
      <p>
        Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen des Verantwortlichen). Der Betreiber hat ein
        berechtigtes Interesse an einer gut lesbaren und strukturierten Darstellung von Schriften und Inhalten (Usability) auf der Webseite.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Newsletter
      </Typography>
      <p>
        Wir bieten die Möglichkeit, sich per Newsletter über Neuerungen auf unserer Webseite zu informieren. Hierfür benötigen wir Ihre E-Mail-Adresse. Wenn Sie
        zu einem späteren Zeitpunkt den Newsletter nicht mehr beziehen möchten, ist dies über eine einfache E-Mail Abmeldung möglich.
      </p>
      <p>
        Sofern Sie eine Einwilligung in die werbliche Ansprache durch LBRA erteilt haben, erhebt, verarbeitet und nutzt LBRA Ihre Nutzerprofil-Daten,
        Buchungsdaten und Zusatzinformationen sowie Ihre Zugriffszeiten auf Ihr Nutzerprofil, um Ihre Nutzergewohnheiten besser zu verstehen und Ihnen für Sie
        möglicherweise interessante Informationen zu weiteren Dienstleistung zu übersenden. Sie können eine einmal erteilte Einwilligung in die Nutzung Ihrer
        Daten für werbliche Zwecke (z.B. Newsletter) durch LBRA und Anwalt von LBRA jederzeit durch E-Mail an {SERVICE_EMAIL} widerrufen.
      </p>
      <p>
        Rechtsgrundlage für die Verarbeitung der Daten nach Anmeldung zum Newsletter durch den Nutzer ist die Einwilligung des Nutzers, Art. 6 Abs. 1 lit. a
        DSGVO. Rechtsgrundlage für den Versand des Newsletters infolge des Verkaufs von Dienstleistungen ist § 7 Abs. 3 UWG.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Persönliches Legalbird-Konto
      </Typography>
      <p>
        Bei der Anmeldung auf unserer Website müssen Sie Ihre E-Mail-Adresse angeben und Ihr Kennwort festlegen (<strong>"Nutzerprofil-Daten"</strong>). Diese
        Daten benötigen Sie zur Einrichtung Ihres individuellen, nur für Sie zugänglichen Nutzerkontos (<strong>"Legalbird-Konto"</strong>) bei der Legalbird
        GmbH (<strong>"Legalbird"</strong>). Ihr Legalbird-Konto gibt Ihnen die Möglichkeit, Ihre gesamten Daten für Rechtsangelegenheiten zentral an einem Ort
        zu sammeln, zu strukturieren, sicher in der Cloud zu speichern und/oder zu synchronisieren und uns auf einfache Weise zugänglich zu machen (
        <strong>"Legalbird-Dienste"</strong>).
        <br />
        Die Kanzlei nutzt Legalbird OS zur Mandatsbearbeitung. Ohne Legalbird OS ist die Bearbeitung Ihres Mandats nicht möglich. Zudem setzt die Kanzlei die AI
        von Legalbird ein, um die Mandatsbearbeitung zu optimieren.
        <br />
        Das Anlegen eines Legalbird-Kontos ist freiwillig und erleichtert uns die Mandatsbearbeitung. Sollten Sie von diesem Angebot Gebrauch machen, unterliegt
        die Nutzung der Legalbird-Dienste den Nutzungsbedingungen von Legalbird und wir haben keinen Einfluss darauf, wie Legalbird Ihre Daten verarbeitet.
        Bitte machen Sie sich daher mit den Datenschutzbestimmungen von Legalbird vertraut.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Weitere persönliche Daten und Falldaten
      </Typography>
      <p>
        Wenn Sie uns mandatieren, erheben wir unter anderem Informationen wie z.B. Anrede, Vorname, Nachname, E-Mail-Adresse, Anschrift, Telefonnummer (
        <strong>"weitere persönliche Daten"</strong>) oder andere Informationen, die für die Geltendmachung und Verteidigung Ihrer Rechte im Rahmen des Mandats
        oder Falles notwendig sind (<strong>"Falldaten"</strong>), z.B. Arbeitsverträge, zu Ihrer Rechtsschutzversicherung, zu Ihrem Arbeitgeber, zu Ihrer
        Ordnungswidrigkeit oder zu Ihrem Ehepartner. Die Erhebung dieser Daten erfolgt, um Sie als unseren Mandanten identifizieren zu können, um Sie angemessen
        anwaltlich beraten und vertreten zu können, zur Korrespondenz mit Ihnen, zur Rechnungsstellung, zur Abwicklung von evtl. vorliegenden Haftungsansprüchen
        sowie der Geltendmachung etwaiger Ansprüche gegen Sie. Die Datenverarbeitung erfolgt auf Ihre Anfrage hin und ist nach Art. 6 Abs. 1 S. 1 lit. b DSGVO
        zu den genannten Zwecken für die angemessene Bearbeitung des Mandats und für die beidseitige Erfüllung von Verpflichtungen aus dem Mandatsvertrag
        erforderlich.
      </p>
      <p>
        Diese Daten werden von uns in anonymisierter Form zur Auswertung und Verbesserung unserer Dienste genutzt. Ein Rückschluss auf Ihre Person ist dabei
        ausgeschlossen.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Bewerbung über Bewerbungstool
      </Typography>
      <p>
        Wenn Sie sich bei uns als Bewerber vorstellen möchten, können Sie unser Online-Bewerbungstool nutzen. Dazu müssen Sie Ihren Namen und Ihre
        E-Mail-Adresse sowie weitere für Ihre Bewerbung relevante Unterlagen (z.B. Lebenslauf, Zeugnisse, Nachweise, etc.) (<strong>"Bewerbungsdaten"</strong>)
        übermitteln.
      </p>
      <p>
        Die Bewerbungsdaten werden ausschließlich von den zuständigen bearbeitenden Stellen genutzt. Wir werden Ihre Bewerbungsdaten ausschließlich für das
        Bewerbungsverfahren und für anonymisierte Statistiken verwenden. Eine darüber hinausgehende Nutzung oder Weitergabe Ihrer Bewerbungsdaten an Dritte
        gemäß II. erfolgt nicht.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Nutzung von KI zur unterstützenden Mandatsbearbeitung
      </Typography>
      <p>
        Zur Unterstützung unserer anwaltlichen Mandatsbearbeitung setzen wir KI-gestützte Technologien ein. Dazu gehört unsere Legalbird AI, die auf Modelle
        externer KI-Anbieter wie{" "}
        <strong>Google Ireland Limited (über die Plattform Google Vertex AI, z. B. zur automatisierten Texterkennung und Dokumentenanalyse)</strong> und OpenAI
        Ireland Limited zurückgreift. Diese Systeme dienen insbesondere der strukturierten Auswertung und Aufbereitung von Fallinformationen,{" "}
        <strong>der automatisierten Erkennung von Textinhalten aus Dokumenten</strong> sowie der internen Unterstützung bei der juristischen Analyse und
        Recherche. Ziel ist es, unsere Arbeitsprozesse effizienter zu gestalten und unsere Beratungsqualität zu verbessern.
      </p>
      <p>
        Die Verarbeitung personenbezogener Daten erfolgt auf Grundlage unseres berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO an einer modernen,
        effizienten und qualitativ hochwertigen Mandatsbearbeitung. Sie können dieser Verarbeitung jederzeit aus Gründen, die sich aus Ihrer besonderen
        Situation ergeben, widersprechen (Art. 21 DSGVO).
      </p>
      <p>
        Die Beauftragung von <strong>Google Ireland Limited</strong> und <strong>OpenAI Ireland Limited</strong> erfolgt gemäß Art. 28 DSGVO in Verbindung mit
        entsprechenden Auftragsverarbeitungsverträgen. Diese Anbieter agieren dabei als weisungsgebundene Auftragsverarbeiter und nutzen die übermittelten Daten
        nicht für eigene Zwecke. Ihre personenbezogenen Daten können an Google Ireland Limited, OpenAI Ireland Limited und deren verbundene Unternehmen
        weitergegeben werden. Es ist möglich, dass dies auch eine <strong>Datenübermittlung an verbundene Unternehmen in den USA</strong> umfasst. In diesem
        Zusammenhang stellen wir durch geeignete Schutzmaßnahmen sicher, dass Ihre Daten im Einklang mit den Art. 44 ff. DSGVO verarbeitet werden. Weitere
        Informationen finden Sie in den 'Data Processing Addenda' (DPA) der jeweiligen Anbieter.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Gesprächsaufzeichnung und Zusammenfassung
      </Typography>
      <p>
        Sofern Sie Ihre Einwilligung erteilen, können Beratungsgespräche zu Dokumentationszwecken aufgezeichnet werden. Die Aufzeichnung erfolgt über den von
        uns genutzten Softwaredienstleister, der hierzu die technischen Dienste von <strong>Twilio Ireland Limited</strong> nutzt. Zweck der Aufzeichnung ist
        ausschließlich die Erstellung einer KI-gestützten Gesprächszusammenfassung. Diese Zusammenfassung erfolgt mithilfe eines der{" "}
        <strong>KI-Dienstleister, die im Abschnitt "Nutzung von KI zur unterstützenden Mandatsbearbeitung" genannt sind</strong>, und dient dazu, Ihre
        rechtliche Beratung besser nachvollziehbar zu dokumentieren. Die Verarbeitung Ihrer Gesprächsdaten erfolgt ausschließlich mit Ihrer vorherigen
        ausdrücklichen Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Zusätzlich können pseudonymisierte Gesprächszusammenfassungen zu Qualitätssicherungs- und
        Trainingszwecken verwendet werden. Diese Daten werden unter Anwendung geeigneter technischer und organisatorischer Maßnahmen verarbeitet und enthalten
        keine unmittelbar identifizierbaren personenbezogenen Informationen.
      </p>
      <p>
        Unser Softwaredienstleister <strong>Twilio Ireland Limited ist in Europa ansässig</strong>. Für mögliche Datenübermittlungen in Drittstaaten durch die
        eingesetzten KI-Dienstleister verweisen wir auf die Informationen im Abschnitt <strong>"Nutzung von KI zur unterstützenden Mandatsbearbeitung"</strong>.
        Die Gesprächsaufzeichnungen werden spätestens 14 Tage nach Gesprächsende gelöscht. Die Zusammenfassungen selbst werden bis zum Ende
        Ihres Mandats gespeichert.
      </p>
      <p>
        Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen. Ein Widerruf führt zur sofortigen Beendigung der
        Gesprächsaufzeichnung und zur Löschung bereits aufgezeichneter Daten. Unser Softwaredienstleister hat mit Twilio und den eingesetzten KI-Dienstleistern
        entsprechende Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO abgeschlossen, um sicherzustellen, dass Ihre personenbezogenen Daten nur nach unserer
        Weisung verarbeitet und nicht für andere Zwecke genutzt werden. Das Data-Protection-Addendum von Twilio finden Sie unter:{" "}
        <a href={"https://www.twilio.com/en-us/legal/data-protection-addendum/"} target={"_blank"}>
          Data Protection Addendum
        </a>
        .
      </p>
      <Typography variant={"h3"} sx={privacyStyle.headline}>
        II. Weitergabe an Dritte
      </Typography>
      <p>
        Soweit Sie uns personenbezogene Daten übermittelt oder mitgeteilt haben, verwenden wir diese nur zur Beantwortung Ihrer Anfragen, zur Abwicklung mit
        Ihnen geschlossener Verträge, zur Bearbeitung Ihrer uns erteilten Aufträge sowie für die technische Administration, weitere Aktenführung und Abrechnung.
        Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur, soweit dies zur{" "}
        <strong>Bereitstellung und Nutzung unserer Dienste, zur Zahlungsabwicklung oder zur effizienten Bearbeitung Ihres Falles</strong> erforderlich ist.
        Diese Weitergaben sind für die ordnungsgemäße Erbringung unserer Dienstleistungen erforderlich und erfolgen im Einklang mit den geltenden
        Datenschutzvorschriften.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Unsere Dienstleister
      </Typography>
      <p>
        Wir beauftragen dritte Unternehmen mit der Erfüllung von Aufgaben zum Zweck der Bereitstellung unserer Dienste ("Auftragsverarbeiter"). Unsere
        Auftragsverarbeiter haben Zugang zu personenbezogenen Daten, die zur Erfüllung ihrer Aufgaben benötigt werden. Wir verlangen von unseren
        Auftragsverarbeitern im Rahmen der gesetzlichen Anforderungen eine Einverständniserklärung zur vertraulichen Behandlung sämtlicher an diese
        weitergegebener Informationen sowie zur ausschließlichen Nutzung der Informationen im Rahmen des Vertragszwecks.
      </p>
      <p>
        Für die effiziente Bearbeitung Ihres Mandats, erfolgt eine Weitergabe von personenbezogenen Daten an Legalbird, wobei Sie uns ausdrücklich von der
        anwaltlichen Verschwiegenheitspflicht entbinden. Darüber hinaus können personenbezogene Daten an externe Dienstleister weitergegeben werden, sofern dies
        zur Verbesserung der Fallbearbeitung oder zur Effizienzsteigerung beiträgt. Sie haben das jederzeitige Recht, eine uns bereits erteilte Einwilligung mit
        Wirkung für die Zukunft zu widerrufen.
      </p>
      <p>
        Eine Übermittlung personenbezogener Daten an Länder außerhalb der Europäischen Union (EU) bzw. des Europäischen Wirtschaftsraums (EWR) erfolgt
        grundsätzlich nicht.{" "}
        <strong>
          Sollte in Einzelfällen eine solche Übermittlung erforderlich sein – etwa zur Nutzung bestimmter Dienste (z.B. Zahlungsdienstleister, IT-Dienstleister
          oder die unter "Nutzung von KI zur unterstützenden Mandatsbearbeitung" genannten KI-Dienstleister mit Sitz in Drittstaaten) – erfolgt sie nur im
          Einklang mit den Vorgaben der Art. 44 ff. DSGVO.
        </strong>
      </p>
      <p>
        Dabei stellen wir sicher, dass passende <strong>Standardvertragsklauseln (SCCs)</strong> der EU-Kommission oder vergleichbare Schutzmaßnahmen verwendet
        werden, um ein angemessenes Datenschutzniveau zu gewährleisten. Eine Übermittlung personenbezogener Daten an Länder außerhalb der Europäischen Union
        (EU) bzw. des Europäischen Wirtschaftsraums (EWR) erfolgt grundsätzlich nicht.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Rechtswidrige Nutzung unserer Website
      </Typography>
      <p>
        Wenn es zur Aufklärung einer rechtswidrigen Nutzung unserer Website dient oder für die Rechtsverfolgung erforderlich ist, werden personenbezogene Daten
        an die Strafverfolgungsbehörden sowie ggf. an geschädigte Dritte weitergeleitet. Dies geschieht jedoch nur dann, wenn konkrete Anhaltspunkte für ein
        gesetzwidriges bzw. missbräuchliches Verhalten vorliegen. Eine Weitergabe kann auch dann stattfinden, wenn dies der Durchsetzung der AGB oder anderer
        Vereinbarungen dient. LBRA ist zudem gesetzlich verpflichtet, auf Anfrage bestimmten öffentlichen Stellen Auskunft zu erteilen. Dies sind
        Strafverfolgungsbehörden, Behörden, die bußgeldbewährte Ordnungswidrigkeiten verfolgen und die Finanzbehörden.
      </p>
      <p>
        Soweit dies nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von Mandatsverhältnissen mit Ihnen erforderlich ist, werden Ihre personenbezogenen
        Daten an Verfahrensgegner und deren Vertreter (insbesondere deren Rechtsanwälte) sowie Gerichte und andere öffentliche Behörden zum Zwecke der
        Korrespondenz sowie zur Geltendmachung und Verteidigung Ihrer Rechte weitergegeben. Die weitergegebenen Daten dürfen von dem Dritten ausschließlich zu
        den genannten Zwecken verwendet werden. Das Anwaltsgeheimnis bleibt unberührt. Soweit es sich um Daten handelt, die dem Anwaltsgeheimnis unterliegen,
        erfolgt eine Weitergabe an Dritte nur in Absprache mit Ihnen.
      </p>
      <Typography variant={"h3"} sx={privacyStyle.headline}>
        III. Datensicherheit
      </Typography>
      <p>
        Ihre personenbezogenen Daten werden während der Übertragung über das Internet mittels Transport Layer Security / Secure Sockets Layer (TLS / SSL)
        verschlüsselt.
      </p>
      <p>
        Wir sichern unsere Website und sonstigen Systeme durch technische und organisatorische Maßnahmen gegen Verlust, Zerstörung, Zugriff, Veränderung oder
        Verbreitung Ihrer Daten durch unbefugte Personen.
      </p>
      <Typography variant={"h3"} sx={privacyStyle.headline}>
        IV. Speicherdauer und Löschung
      </Typography>
      <p>
        Die für die Mandatierung von uns erhobenen personenbezogenen Daten werden bis zum Ablauf der gesetzlichen Aufbewahrungspflicht für Anwälte (6 Jahre nach
        Ablauf des Kalenderjahres, in dem das Mandat beendet wurde,) gespeichert und danach gelöscht, es sei denn, dass wir nach Artikel 6 Abs. 1 S. 1 lit. c
        DSGVO aufgrund von steuer- und handelsrechtlichen Aufbewahrungs- und Dokumentationspflichten (aus HGB, StGB oder AO) zu einer längeren Speicherung
        verpflichtet sind oder Sie in eine darüber hinausgehende Speicherung nach Art. 6 Abs. 1 S. 1 lit. a DSGVO eingewilligt haben.
      </p>
      <p>
        Soweit Ihre Daten für die vorgenannten Zwecke nicht mehr erforderlich sind, werden sie gelöscht. Soweit Daten aus gesetzlichen Gründen aufbewahrt werden
        müssen, werden diese gesperrt. Die Daten stehen einer weiteren Verwendung dann nicht mehr zur Verfügung.
      </p>
      <p>
        Sie können Ihre personenbezogenen Daten nicht selbständig löschen, jedoch jederzeit eine Löschung Ihrer Daten per E-Mail an {SERVICE_EMAIL} anfordern.
        Wir löschen Ihre Daten auf Anforderung, insofern diese nicht aus Abrechnungsgründen oder zur Wahrung gesetzlicher Aufbewahrungsfristen benötigt werden.
      </p>
      <Typography variant={"h3"} sx={privacyStyle.headline}>
        VI. Ihre Rechte
      </Typography>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Widerrufsrecht
      </Typography>
      <p>Sie können Ihre Einwilligung zur Erhebung und Verarbeitung Ihrer personenbezogenen Daten durch uns jederzeit widerrufen.</p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Auskunftsanspruch
      </Typography>
      <p>
        Sie haben das Recht, gemäß § 34 BDSG bzw. Art. 15 DSGVO jederzeit von uns Auskunft zu verlangen über die zu Ihrer Person gespeicherten Daten, auch
        soweit sie sich auf die Herkunft dieser Daten beziehen, ebenso zu den Empfängern oder den Kategorie von Empfängern, an die Ihre Daten weitergegeben
        werden, sowie zum Zweck der Speicherung.
      </p>
      <Typography variant={"h4"} sx={privacyStyle.headline}>
        Weitere Rechte
      </Typography>
      <p>
        Sie haben das Recht, gemäß Art. 16 DSGVO die Berichtigung unrichtiger personenbezogener Daten und gemäß Art. 17 DSGVO die Löschung oder gemäß Art. 18
        DSGVO die Sperrung oder Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Ferner können Sie gemäß Art. 20 DSGVO die Herausgabe
        der zu Ihnen gespeicherten personenbezogenen Daten in einem gängigen Dateiformat an Sie selbst oder einen Dritten verlangen. Sofern wir Ihre
        personenbezogenen Daten aufgrund unserer überwiegenden Interessen (Art. 6 Abs. 1 lit. f DSGVO) verarbeiten, können Sie einer darauf gestützten
        Verarbeitung gemäß Art. 21 DSGVO widersprechen, sofern hierfür überwiegende Gründe bestehen, die sich aus Ihrer besonderen Situation ergeben. Sie können
        ferner der Zusendung von Direktwerbung widersprechen. Sollten Sie der Auffassung sein, dass wir Ihre Daten nicht im Einklang mit geltendem Recht
        verarbeiten, können Sie eine Beschwerde bei einer zuständigen Aufsichtsbehörde einlegen, z.B. an Ihrem Wohnort.
      </p>
      <p>Stand: 21.04.2026</p>
    </Box>
  );
};

export default PrivacyLawFirm;
